import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function FaqQuestion(props: BaseMsgProps) {
  const { faqQuestionContent } = props.raw;

  if (!faqQuestionContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex {...props} content={<Container>{faqQuestionContent.text}</Container>} />
  );
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
`;

export default FaqQuestion;
